module.exports = __webpack_public_path__ + "img/bank_icon11.e5247100.png";